export enum IModalTypes {
  SUBMIT_MODAL_REQUEST = '@modal/SUBMIT_MODAL_REQUEST',
  SUBMIT_MODAL_SUCCESS = '@modal/SUBMIT_MODAL_SUCCESS',
  SUBMIT_MODAL_FAILURE = '@modal/SUBMIT_MODAL_FAILURE',
  SUBMIT_MODAL_RESET = '@modal/SUBMIT_MODAL_RESET',
}

export interface ISubmitModalRequestAction {
  type: typeof IModalTypes.SUBMIT_MODAL_REQUEST;
}
export interface ISubmitModalSuccessAction {
  type: typeof IModalTypes.SUBMIT_MODAL_SUCCESS;
}
export interface ISubmitModalFailureAction {
  type: typeof IModalTypes.SUBMIT_MODAL_FAILURE;
}
export interface ISubmitModalResetAction {
  type: typeof IModalTypes.SUBMIT_MODAL_RESET;
}

export type IModalActionsType =
  | ISubmitModalRequestAction
  | ISubmitModalSuccessAction
  | ISubmitModalResetAction
  | ISubmitModalFailureAction;

export interface IModalState {
  loadingSubmit: boolean;

  submitStatus: StatusOption;
}

export enum StatusOption {
  REQUEST = 'request',
  SUCCESS = 'success',
  FAILURE = 'failure',
}
